import { Modal } from 'react-bootstrap';
import { useState } from "react";
import { validEmail, notNullOrEmpty, validUKPhoneNumber, validateField, isNumber } from "../../utils/validators";
import { FloatingEmailInput } from "../reusable-elements/floating-email-input";
import { FloatingTextInput } from "../reusable-elements/floating-text-input";
import Comparer from "../../app/comparer";
import ObjectID from 'bson-objectid';

export const NewTenantModal = ({ show, handleCancel, handleSave }) => {

    const comparer = new Comparer();
    const defaultTenant = { id: new ObjectID().toHexString(), emailAddress: null, displayName: null, firstName: null, lastName: null, phoneNumber: null, currentRentAmount: null };

    const [newTenant, setNewTenant] = useState(structuredClone(defaultTenant));
    const [validationErrors, setValidationErrors] = useState(null);
    const [rerender, setRerender] = useState(false);

    const validateState = newState => {
        // Validate fields that the user can change and that you care about the contents of
        validateField(() => notNullOrEmpty(newState.emailAddress) && validEmail(newState.emailAddress), () => newState.emailAddress, setValidationErrors);
        validateField(() => notNullOrEmpty(newState.displayName), () => newState.displayName, setValidationErrors);
        validateField(() => notNullOrEmpty(newState.firstName), () => newState.firstName, setValidationErrors);
        validateField(() => notNullOrEmpty(newState.lastName), () => newState.lastName, setValidationErrors);
        validateField(() => notNullOrEmpty(newState.phoneNumber) && validUKPhoneNumber(newState.phoneNumber), () => newState.phoneNumber, setValidationErrors);
        validateField(() => isNumber(newState.currentRentAmount), () => newState.currentRentAmount, setValidationErrors);
    };

    const handleStateUpdates = updateMethod => {

        setNewTenant(current => {
            const newState = updateMethod(current);
            validateState(newState);
            return newState;
        });
        setRerender(!rerender);

    };
    const hasChanges = () => {
        const equal = comparer.equals(newTenant, defaultTenant);
        return !equal;
    };

    const canSave = () => {
        return hasChanges() && Object.keys(validationErrors ?? {}).length === 0;
    };

    const localHandleCancel = () => {
        setNewTenant(structuredClone(defaultTenant));
        handleCancel();
    }

    const localHandleSave = () => {
        handleSave(newTenant);
        setNewTenant(structuredClone(defaultTenant));
    }

    return (
        <Modal
            show={show}
            onHide={localHandleCancel}
            backdrop="static"
            keyboard={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>Add New Tenant</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newTenant.displayName ? "Enter" : ""} Display Name`}
                    text={newTenant.displayName}
                    updateCallback={newValue => { handleStateUpdates(v => { v.displayName = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newTenant.displayName) }}
                    readOnly={false}
                />
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newTenant.firstName ? "Enter" : ""} First Name`}
                    text={newTenant.firstName}
                    updateCallback={newValue => { handleStateUpdates(v => { v.firstName = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newTenant.firstName) }}
                    readOnly={false}
                />
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newTenant.lastName ? "Enter" : ""} Last Name`}
                    text={newTenant.lastName}
                    updateCallback={newValue => { handleStateUpdates(v => { v.lastName = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newTenant.lastName) }}
                    readOnly={false}
                />
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newTenant.phoneNumber ? "Enter" : ""} Phone Number`}
                    text={newTenant.phoneNumber}
                    updateCallback={newValue => { handleStateUpdates(v => { v.phoneNumber = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newTenant.phoneNumber) && validUKPhoneNumber(newTenant.phoneNumber) }}
                    readOnly={false}
                />
                <FloatingEmailInput
                    className={"mt-1"}
                    label={`${!newTenant.emailAddress ? "Enter" : ""} Email Address`}
                    email={newTenant.emailAddress}
                    updateCallback={newValue => { handleStateUpdates(v => { v.emailAddress = newValue; return v; }) }}
                    validatorFn={() => { return notNullOrEmpty(newTenant.emailAddress) && validEmail(newTenant.emailAddress); }}
                    readOnly={false}
                />
                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newTenant.currentRentAmount ? "Enter" : ""} Initial Rent Amount`}
                    text={newTenant.currentRentAmount}
                    updateCallback={newValue => { handleStateUpdates(v => { v.currentRentAmount = parseFloat(newValue); return v; }) }}
                    validatorFn={() => { return isNumber(newTenant.currentRentAmount) }}
                    readOnly={false}
                />

            </Modal.Body>
            <Modal.Footer>
                <div className='btn-group'>
                    <button disabled={!canSave()} className='btn btn-primary' onClick={localHandleSave}>
                        Save
                    </button>
                    <button className='btn btn-secondary' onClick={localHandleCancel}>
                        Close
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );

};